module.exports = __webpack_public_path__ + "img/4-3.1682a318.png";